import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'TextBlock',
  props: {
    block: {},
    pageIndex: {},
    blockIndex: {}
  },
  emits: ["update", "contentEdit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function onContentChange(event: Event) {
  const target = event.target as HTMLElement;
  emit("update", { content: target.innerHTML });
  emit("contentEdit");
}

function onInput() {
  emit("contentEdit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-block",
    style: _normalizeStyle(__props.block.style),
    contenteditable: "true",
    onBlur: onContentChange,
    onInput: onInput,
    innerHTML: __props.block.data.content
  }, null, 44, _hoisted_1))
}
}

})